import {formatMoney, formatNumber} from 'accounting'
import React from 'react'

import {usePreferences} from '@/components/context/Preferences'
import {Currency, getFormattingOptions} from '@/utils/currency'
import {useLanguage} from '@/utils/i18n/language'

type LocalizedNumberFormatProps = {
  value: number
  type?: 'number' | 'currency'
  currency?: Currency | undefined
  hasDecimal?: boolean
}

export const LocalizedNumberFormat: React.FC<
  React.PropsWithChildren<LocalizedNumberFormatProps>
> = ({value, type = 'number', currency, hasDecimal = false}) => {
  const language = useLanguage()
  const preferences = usePreferences()

  const formattingOptions = getFormattingOptions(
    currency ?? preferences.currency,
    language,
    hasDecimal,
  )
  return (
    <>
      {type === 'number'
        ? formatNumber(value, formattingOptions)
        : formatMoney(value, formattingOptions)}
    </>
  )
}
